import React from 'react';
import { MousePointer2 } from 'lucide-react';
import { Link } from 'react-router-dom';




const reasons = [
    {
        title: "No Repairs Needed",
        description: "Tell us everything about the property, the type of house it is, and the condition the house is in at the moment."
    },
    {
        title: "No Commission",
        description: "You won't have to pay a real estate agent's commission, which means you keep more of the sale price."
    },
    {
        title: "Pick your closing date",
        description: " You have flexibility to choose the date that works best for you, making the process convenient."
    },
    {
        title: "No Fees",
        description: "There are no hidden fees or costs, providing transparency and peace of mind."
    }
]

export default function WhySellToUsSection() {
  return (
    <div className='py-[75px] flex justify-center px-[20px] md:px-[40px]'>
    <div className='flex flex-col md:flex-row md:space-x-[125px] justify-between w-full max-w-[1300px]'>
        <div className='w-full md:w-1/2'>
            <div className='mb-[24px]'>
                <h4 className='text-[#FF8E00] font-extrabold text-[32px] md:text-[48px] leading-[40px] md:leading-[60px] font-cabinet'>
                    Why you should <br/>sell to us
                </h4>
            </div>
            {
                reasons.map((item, index)=>{
                    return(
                        <div className='px-[16px] mb-[28px]  border-[#000] border-l-[1px]' key={index}>
                            <h4 className='text-[20px] font-extrabold text-[#03002F] leading-[25px] mb-[5px] font-cabinet'>{item.title}</h4>
                            <p className='text-[#757272] text-[14px] md:text-[16px] font-bold font-satoshi'>{item.description}</p>
                        </div>
                    )
                })
            }
        </div>
        <div className='w-full md:w-1/2'>
            <div className='bg-gradient-to-br from-[#03002F] via-[#05003d] to-[#03002F] min-h-[500px] relative overflow-hidden flex items-center justify-center px-6 rounded-[24px] md:rounded-[32px]'>
      {/* Animated background elements */}
      <div className='absolute inset-0 opacity-10'>
        <div className='absolute top-20 left-20 w-64 h-64 bg-[#FFBD00] rounded-full blur-3xl animate-pulse'></div>
        <div className='absolute bottom-20 right-20 w-96 h-96 bg-[#FFBD00] rounded-full blur-3xl animate-pulse' style={{animationDelay: '1s'}}></div>
      </div>

      {/* Main content */}
      <div className='relative z-10 text-center max-w-4xl'>
        <div className='inline-block mb-6'>
          {/* Pulsing cursor icon */}
          <div className='relative'>
            <MousePointer2 
              className='text-[#FFBD00] w-16 h-16 animate-pulse' 
              strokeWidth={2}
            />
            <div className='absolute inset-0 bg-[#FFBD00] rounded-full blur-xl opacity-50 animate-ping'></div>
          </div>
        </div>

        <h4 className='text-[#FFBD00] text-5xl md:text-6xl lg:text-7xl font-bold mb-6 tracking-tight font-cabinet'>
          Get Your Offer!
        </h4>
        
        <p className='text-gray-300 text-lg md:text-xl mb-8 max-w-2xl mx-auto leading-relaxed font-satoshi'>
          Sell your property fast with a competitive cash offer. No fees, no commissions, no waiting.
        </p>
        <Link to="/get-offer">
        <button className='group relative bg-[#FFBD00] text-[#03002F] px-8 py-4 rounded-full font-bold text-lg transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-[#FFBD00]/50 overflow-hidden'>
          <span className='relative z-10 flex items-center gap-2 font-satoshi'>
            Get Started Now
            <MousePointer2 className='w-5 h-5 group-hover:translate-x-1 transition-transform' />
          </span>
          <div className='absolute inset-0 bg-gradient-to-r from-[#FFD700] to-[#FFBD00] opacity-0 group-hover:opacity-100 transition-opacity'></div>
        </button>
        </Link>

        <div className='mt-10 flex items-center justify-center gap-8 text-gray-400 text-sm font-satoshi'>
          <div className='flex items-center gap-2'>
            <div className='w-2 h-2 bg-[#FFBD00] rounded-full animate-pulse'></div>
            <span>Fast Process</span>
          </div>
          <div className='flex items-center gap-2'>
            <div className='w-2 h-2 bg-[#FFBD00] rounded-full animate-pulse' style={{animationDelay: '0.5s'}}></div>
            <span>No Hidden Fees</span>
          </div>
          <div className='flex items-center gap-2'>
            <div className='w-2 h-2 bg-[#FFBD00] rounded-full animate-pulse' style={{animationDelay: '1s'}}></div>
            <span>Cash Offers</span>
          </div>
        </div>
      </div>

      {/* Decorative corner elements */}
      <div className='absolute top-0 left-0 w-32 h-32 border-t-2 border-l-2 border-[#FFBD00] opacity-30'></div>
      <div className='absolute bottom-0 right-0 w-32 h-32 border-b-2 border-r-2 border-[#FFBD00] opacity-30'></div>
    </div>
        </div>
    </div>

    </div>

  )
}
